import React from 'react';

const ThemeProviderContext = React.createContext({});

export default ThemeProviderContext;
